export default ['editarGestor', 'criarGestor', 'listarPerfilUsuario', 'criarPerfilUsuario', 'editarPerfilUsuario'];
